export const LOADER_STATUS = 'boilerplate/gstinreport/LOADER_STATUS';
export const SET_PAGE_COUNT = 'boilerplate/gstinreport/SET_PAGE_COUNT';
export const SET_PAGE_DATA = 'boilerplate/gstinreport/SET_PAGE_DATA';
export const SET_CURRENT_PAGE = 'boilerplate/gstinreport/SET_CURRENT_PAGE';